/**************************************************
 * Nombre:       PaginaDos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Backdrop, Button, CircularProgress, Fade, Grid, Snackbar} from "@mui/material";
import {theme} from "../Tema";
import Apartado_Portada_Dos from "./Apartados/Apartado_Portada_Dos";
import Apartado_Video from "./Apartados/Apartado_Video";
import Apartado_Texto_Boton from "./Apartados/Apartado_Texto_Boton";
import Apartado_Lineas_Texto from "./Apartados/Apartado_Linea_Texto";
import Apartado_Indicadores from "./Apartados/Apartado_Indicadores";
import Apartado_Antes_Despues from "./Apartados/Apartado_Antes_Despues";
import Apartado_Pasos from "./Apartados/Apartado_Pasos";
import Apartado_Boton_Abajo from "./Apartados/Apartado_Boton_Abajo";
import Apartado_Preguntas from "./Apartados/Apartado_Preguntas";
import Footer from "./Footer";
import {useResponsive} from "../Modulo_Responsive/Hooks/useResponsive";
import {usePasoActual} from "../CodigoCliente/Hooks/usePasoActual";
import {useEffect, useState} from "react";
import logo from '../Recursos/logo.svg'
import {incremetarMetrica} from "../Servicios/BD/Metricas/incremetarMetrica";
import {obtenerParametrosUrl} from "../CodigoCliente/Funciones/obtenerParametrosUrl";
import Dialogo_Felicitaciones from "./Dialogos/Dialogo_Felicitaciones";
import {Undo} from "@mui/icons-material";


const PaginaDos = () => {
    const {sCell} = useResponsive()
    const [termino, setTermino] = useState(false)
    const {actual, siguiente, Dialogo: DialogoFunnel} = usePasoActual({setTermino: setTermino})
    const [abrirToast, setAbrirToast] = useState(false)
    const [cargando, setCargando] = useState(false)

    const click = () => {
        let idFunnel = obtenerParametrosUrl({clave: 'id'})
        let idUsuario = obtenerParametrosUrl({clave: 'idUsu'})

        if (termino || actual.numero >= 3) {

            window.fbq('trackCustom', 'Visualizaciones', {
                tipo: 'video',
                nombre: actual.numero,
                funnel: actual.nombre,
                idUsuario: idUsuario
            })

            if (actual.numero === 3) {
                // abrir(actual)
                window.fbq('trackCustom', 'Visualizaciones', {
                    tipo: 'formulario',
                    nombre: 'datos',
                    funnel: actual.nombre,
                    idUsuario: idUsuario
                })

                siguiente()
            } else {

                siguiente()


            }

            incremetarMetrica({idFunnel: idFunnel, idUsuario: idUsuario, propiedad: 'video' + actual.numero}).then()

        } else {
            setAbrirToast(true)
        }
    }

    const reiniciar = () => {

        window.localStorage.clear()
        window.location.reload();
    }


    useEffect(() => {

        if (!actual.numero) {
            setCargando(true)
        } else {
            setCargando(false)
        }

    }, [actual])

    useEffect(() => {

        let idFunnel = obtenerParametrosUrl({clave: 'id'})
        let idUsuario = obtenerParametrosUrl({clave: 'idUsu'})

        if (idUsuario && idFunnel) {
            incremetarMetrica({idFunnel: idFunnel, idUsuario: idUsuario, propiedad: 'vistaPagina'}).then()
        }

    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <DialogoFunnel/>

            <Backdrop
                sx={(theme) => (
                    {
                        color: '#fff',
                        zIndex: theme.zIndex.drawer + 1,
                        backgroundColor: '#ffffff50',
                        backdropFilter: 'blur(15px)',

                    }
                )}
                open={cargando}

            >
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <img src={logo} width={250} height={'auto'}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                        <CircularProgress
                            color="inherit"/>
                    </Grid>

                </Grid>

            </Backdrop>


            <Snackbar
                open={abrirToast}
                onClose={() => setAbrirToast(false)}
                slots={{transition: Fade}}
                message="Finaliza el video antes de continuar"
                autoHideDuration={3000}
            />

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: theme.palette.primary.main,
                }}
            >

                {/*} <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Button
                        variant={'contained'}
                        color={'secondary'}
                        onClick={() => incremetarMetrica({idFunnel: actual.idFunnel, idUsuario: actual.idUsuario, propiedad: 'vistaPagina'})}
                    >Ver</Button>
                </Grid>*/}

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                    <Apartado_Portada_Dos item={actual}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: sCell ? -11 : -13, zIndex: 2}}>
                    <Apartado_Video item={actual} click={click} setTermino={setTermino} termino={termino}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                    <Apartado_Texto_Boton item={actual} click={click} termino={termino}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                    <Apartado_Lineas_Texto item={actual}/>
                </Grid>

            </Grid>

            {actual && actual.numero >= 3 &&
                <>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                        <Dialogo_Felicitaciones datos={actual}/>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Button
                            variant={'outlined'}
                            onClick={() => reiniciar()}
                            startIcon={<Undo/>}
                            sx={{borderRadius: 8, py: 1.5, px: 4}}
                        >RE INICIAR</Button>
                    </Grid>

                </>

            }

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Apartado_Indicadores item={actual}/>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 14}}>
                <Apartado_Antes_Despues item={actual}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    background: 'linear-gradient(180deg, #F7F3FE 69.51%, rgba(249, 243, 254, 0.00) 99.98%)',
                    mt: 10
                }}
            >
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                    <Apartado_Pasos item={actual}/>
                </Grid>

                {/*} <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 18}}>
                    <Apartado_Testimonios item={actual}/>
                </Grid> */}


            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#250E4A',
                    mt: 14
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Apartado_Boton_Abajo item={actual} click={click} termino={termino}/>
                </Grid>


            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: '#F7F3FE'
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Apartado_Preguntas item={actual}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Footer/>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default PaginaDos    